module.exports = __webpack_public_path__ + "static/media/mesonry-lg-7.fed805c5.jpg";